"use client";

import { cn } from "@/lib/utils";
import { useCountryContext } from "@/providers/country-provider";

const CountryStats = ({ className }: { className?: string }) => {
	console.log("CountryStats: Now a client component using client hook");
	const { stats } = useCountryContext();

	return (
		<div
			className={cn("mx-auto flex w-fit items-center justify-center gap-8 text-left", className)}
		>
			<div className="space-y-1">
				<h3 className="text-2xl font-bold text-brand-primary sm:text-3xl">{stats.products}</h3>
				<span className="block font-medium text-gray-500">Products</span>
			</div>

			<div className="w-px self-stretch bg-gray-300" />

			<div className="space-y-1">
				<span className="text-2xl font-bold text-brand-primary sm:text-3xl">{stats.members}</span>
				<span className="block font-medium text-gray-500">Members</span>
			</div>

			<div className="w-px self-stretch bg-gray-300" />

			<div className="space-y-1">
				<span className="text-2xl font-bold text-brand-primary sm:text-3xl">{stats.views}</span>
				<span className="block font-medium text-gray-500">Views</span>
			</div>

			<div className="w-px self-stretch bg-gray-300" />

			<div className="space-y-1">
				<h3 className="text-2xl font-bold text-brand-primary sm:text-3xl">{stats.communities}</h3>
				<span className="block font-medium text-gray-500">Communities</span>
			</div>

			<div className="w-px self-stretch bg-gray-300" />

			<div className="space-y-1">
				<h3 className="text-2xl font-bold text-brand-primary sm:text-3xl">{stats.courses}</h3>
				<span className="block font-medium text-gray-500">Courses</span>
			</div>
		</div>
	);
};

export default CountryStats;
